import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCirclePlus, faGear } from '@fortawesome/free-solid-svg-icons';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';

export const Container = styled(View)`
  background-color: ${colors.header};
  padding: 20px;
  flex-direction: row;
  gap: 20;
  align-items: center;
  z-index: 9999;
`;

export const SiteTitle = styled(Text)`
  color: white;
  font-size: 22px;
  marginRight: 30px;
`;

const Label = styled(Text)`
  color: white;
`;

const Settings = styled(View)`
  position: absolute;
  right: -20px;
  top: 34px;
  background-color: black;
  padding: 20px;
  width: 200px;
  gap: 20px;
`;

const SETTINGS_ITEMS = [
  {
    path: '/clients',
    label: 'Clients',
  },
  {
    path: '/event-types',
    label: 'Event Types',
  },
  {
    path: '/things',
    label: 'Things',
  },
  {
    path: '/users',
    label: 'Users',
  },
];

const Menu = () => {
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const { logout } = useContext(ClientContext);

  return (
    <Container>
      <Link to="/">
        <SiteTitle>
          Keeping.Care
        </SiteTitle>
      </Link>

      <Link to="/events">
        <Label>Events</Label>
      </Link>

      <Link to="/events/new">
        <FontAwesomeIcon
          icon={faCirclePlus}
          color="white"
          size={18}
          style={{ outlineStyle: 'none' }}
        />
      </Link>

      <Pressable
        onPress={() => setShowSettingsMenu(!showSettingsMenu)}
        style={{ marginLeft: 'auto' }}
      >
        <FontAwesomeIcon
          icon={faGear}
          color="white"
          size={18}
          style={{ outlineStyle: 'none' }}
        />

        {showSettingsMenu && (
          <Settings>
            {SETTINGS_ITEMS.map(({ path, label }) => (
              <Link to={path}>
                <Label>{label}</Label>
              </Link>
            ))}

            <Pressable onPress={logout}>
              <Label>Logout</Label>
            </Pressable>
          </Settings>
        )}
      </Pressable>
    </Container>
  );
};

export default Menu;
